import Listener from '@/plugins/sdk/Listener'

const id = (() => {
  let currentId = 0
  const map = new WeakMap()

  return (object) => {
    if (!map.has(object)) {
      map.set(object, ++currentId)
    }

    return map.get(object)
  }
})()

const listeners = {}

export default class {
  /**
   * Triggers registered listeners for a given event.
   *
   * @param      {Resource}  resource  The resource
   * @param      {String}    event     The event
   * @param      {mixed}     data      The data
   */
  static emit (resource, event, data) {
    if (resource.name in listeners &&
      event in listeners[resource.name]) {
      Object
        .values(listeners[resource.name][event])
        .forEach(listener => {
          if (listener instanceof Listener) {
            listener.callback(data)
          }
        })
    }
  }

  /**
   * Registers an event listener.
   *
   * @param      {Listener}  listener  The event listener
   */
  static register (listener) {
    if (listener instanceof Listener) {
      Object.defineProperty(listener, '_id', {
        configurable: false,
        enumerable: false,
        value: id(listener),
        writable: false
      })

      if (!(listener.resource.name in listeners)) {
        listeners[listener.resource.name] = {}
      }

      for (var i = listener.events.length - 1; i >= 0; i--) {
        if (!(listener.events[i] in listeners[listener.resource.name])) {
          listeners[listener.resource.name][listener.events[i]] = {}
        }

        listeners[listener.resource.name][listener.events[i]][listener._id] = listener
      }
    }
  }

  /**
   * Deregisters an event listener.
   *
   * @param      {Listener}  listener  The event listener
   */
  static deregister (listener) {
    if (listener instanceof Listener &&
      listener.resource.name in listeners) {
      for (var i = listener.events.length - 1; i >= 0; i--) {
        if (listener.events[i] in listeners[listener.resource.name]) {
          delete listeners[listener.resource.name][listener.events[i]][listener._id]
        }
      }
    }
  }
}
